import { Events } from '@vimeo/bigpicture-client';

export const BP_EVENT_NAMES: Record<string, Events> = {
  REGISTRATION_FORM_COMPLETE: 'vimeo.registration_form_complete',
  REGISTRATION_FORM_VIEWED: 'vimeo.registration_form_viewed',
} as const;

export const BP_EVENT_VERSIONS = {
  [BP_EVENT_NAMES.REGISTRATION_FORM_VIEWED]: 3,
  [BP_EVENT_NAMES.REGISTRATION_FORM_COMPLETE]: 4,
} as const;
